<template>
  <button
    class="btn"
    @click="click"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'IButton',
  inheritAttrs: true,
  methods: {
    click (event) {
      this.$emit('click', event)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'

.btn {
  padding: 0.3125em 0.625em
  display: inline-flex
  justify-content: center
  border-radius: 5px
  border: 0
  text-align: center
  letter-spacing: 0
  cursor: pointer

  &:focus {
    outline: none
  }

  &[disabled] {
    opacity: .6
    cursor: default
  }
}

>>> .btn-children {
  display: inline-flex
  align-items: center
}

.btn-yellow {
  background-color: $yellow
  color: $black

  &:not([disabled]):hover {
    background-color: #fcd766
  }
}

.btn-red {
  background-color: $dark-red3
  color: $white

  &:not([disabled]):hover {
    background-color: $dark-red2
  }
}

.btn-lg {
  font-size: 20px
  height: 62px
  min-width: 150px
}

.btn-round {
  border-radius: 15%/100%
}

.btn-ghost {
  border: 0
  background: 0
}

.btn-shadow {
  box-shadow: 0 6px 10px 0 rgba(114, 105, 105, 0.5), 0 0 14px 4px rgba(55, 56, 60, 0.25)
}
</style>
